<script setup lang="ts">
import type { INQUIRY_ITEM } from '@/types'

const props = defineProps<{
  inquiries: INQUIRY_ITEM[]
  isLoading: boolean
}>()

const emits = defineEmits<{
  (e: 'select', inquiry: INQUIRY_ITEM): void
  (e: 'long-press', inquiry: INQUIRY_ITEM): void
}>()

const listContainer = ref<HTMLElement>()
const lastInquiryCount = ref(0)

onMounted(() => {
  lastInquiryCount.value = props.inquiries.length
})

watch(
  () => props.inquiries,
  async (newValue) => {
    if (!newValue) return

    const hadNewInquiry = newValue.length > lastInquiryCount.value
    lastInquiryCount.value = newValue.length

    if (hadNewInquiry && listContainer.value) {
      await nextTick()
      if (listContainer.value) {
        listContainer.value.scrollTop = 0
      }
    }
  },
)
</script>

<template>
  <div
    v-if="!isLoading"
    ref="listContainer"
    class="no-scrollbar min-h-0 flex-1 overflow-auto transition-opacity duration-300 ease-in-out"
  >
    <div v-if="inquiries.length">
      <InquiryListItem
        v-for="item in inquiries"
        :key="item.id"
        v-bind="item"
        @on-long-press="emits('long-press', item)"
        @click="emits('select', item)"
      />
    </div>
    <div v-else>
      <p class="pt-4 text-center text-brand-dark">No inquiries.</p>
    </div>
  </div>
  <div v-else class="flex min-h-0 flex-1 items-center justify-center">
    <AppInlineLoader />
  </div>
</template>
